import { useMemo } from "@wordpress/element";
import { Tabs } from "@/components/tabs";
import { css } from "@/utils/css";
import { __ } from "@wordpress/i18n";
import { CreateNewPosting } from "./new-posting";
import { useRoute } from "@/hooks/use-route";
import { Postings } from "./postings";
import { LuExternalLink } from "react-icons/lu";
import { useAutoPostings } from "@/hooks/use-auto-postings";

export default function AutoPosting() {
    const { updateQuery, query } = useRoute();
    const { data: postings } = useAutoPostings();

    const tabs = [
        {
            label: __("Create new Posting", "antimanual"),
            value: "new-posting",
            element: <CreateNewPosting />,
            description: (
                <div>
                    <span>{__("Set up a new auto posting schedule to generate and publish posts automatically.", "antimanual")}</span>{" "}
                    <span className={css("text-olive font-semibold block mt-1")}>
                        {__(
                            "Important: To ensure auto postings run reliably, please set up a server-side cron job. Without this, scheduled posts may not be generated as expected.",
                            "antimanual"
                        )}{" "}
                        <a
                            className={css("link")}
                            href="https://developer.wordpress.org/plugins/cron/hooking-wp-cron-into-the-system-task-scheduler/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {__("Learn how to set up a server-side cron job", "antimanual")}
                            <LuExternalLink />
                        </a>
                    </span>
                </div>
            ),
        },
        {
            label: __("Postings", "antimanual") + (postings ? ` (${postings.length})` : ""),
            value: "postings",
            element: <Postings />,
            description: __("View and manage existing auto postings.", "antimanual"),
        },
    ];

    const activeTab = useMemo(() => tabs.find((tab) => tab.value === query.tab) || tabs[0], [query.tab]);

    return (
        <div className={css("auto-posting")}>
            <Tabs standalone activeTab={activeTab.value} tabs={tabs} onTabChange={(tab) => updateQuery({ tab })} />

            <div className={css("pb-5 pt-2 px-2")}>
                <h2>{activeTab.label}</h2>
                <p>{activeTab.description || ""}</p>
            </div>

            <div className={css("panel")}>{activeTab.element}</div>
        </div>
    );
}
